import { render } from "./AdminAddUsers.vue?vue&type=template&id=5b734396"
import script from "./AdminAddUsers.vue?vue&type=script&lang=js"
export * from "./AdminAddUsers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__